import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from "../../../../config/apiConfig";


const deletePost = async ({ blogId, deletedById, reason }) => {
  const { data } = await axiosInstance.patch(
    `reports/soft-delete/${blogId}?deletedById=${deletedById}&reason=${reason}`
  );
  return data;
};

 const useDeletePost = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletePost,
    onSuccess: () => {
      queryClient.invalidateQueries(['reportedPosts']); 
    },
    onError: (err) => {
      console.error('Delete post failed', err);
    },
  });
};

export default useDeletePost